/** The colour a status reads in: done, wrong, waiting on someone, or moving. */
export const statusColour = (
  status: string,
): 'success' | 'error' | 'warning' | 'info' | 'default' => {
  switch (status) {
    case 'active':
      return 'success';
    case 'failed':
      return 'error';
    case 'cancelled':
    case 'ceased':
      return 'default';
    case 'cancel_requested':
    case 'change_requested':
    case 'cease_requested':
      return 'warning';
    default:
      return 'info';
  }
};
